<template>
  <div>
    <v-container>
      <advice color="primary" marginLeft="0px">
        <span class="caption grey--text text--darken-1">
          {{$t('profile.changeName.advice')}}
        </span>
      </advice>

      <v-form ref="form"
              class="mt-5"
              v-model="valid">
        <v-text-field :label="$t('global.placeholder.firstname')"
                      v-model="model.firstname"
                      :rules='mandatoryRules'
                      :disabled="!editMode"
                      required></v-text-field>

        <v-text-field :label="$t('global.placeholder.lastname')"
                      v-model="model.lastname"
                      :rules='mandatoryRules'
                      :disabled="!editMode"
                      required></v-text-field>
      </v-form>

    </v-container>

    <v-card-actions class="px-4 pb-3">
      <v-btn v-if="!editMode"
             class="initialize"
             color="accent"
             round
             outline
             @click="unsubscribe">{{$t('profile.changeName.button.unsubscribe')}}</v-btn>

      <v-spacer></v-spacer>

      <v-btn v-if="!editMode"
             color="primary"
             round
             outline
             class="initialize right"
             @click="editMode = !editMode">
        {{$t('global.button.edit')}}</v-btn>

      <v-btn v-if="editMode"
             flat
             color="primary"
             class="initialize right"
             @click=restoreForm>
        {{$t('global.button.cancel')}}</v-btn>
      <v-btn v-if="editMode"
             round
             outline
             color="accent"
             class="initialize right"
             :disabled='!valid'
             :loading="isLoading"
             @click="saveForm">
        {{$t('global.button.save')}}</v-btn>
    </v-card-actions>

    <unsubscribe @on-close="closeUnsubscribe"
                 v-if="isShowingUnsubscribe"></unsubscribe>
  </div>
</template>

<script>
import Advice from '@/components/commons/Advice';
import Unsubscribe from '@/components/private/user/Unsubscribe';
import profileService from '@/services/profileService';
import manageErrorService from '@/services/manageErrorService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ChangeName',
  components: {
    [Advice.name]: Advice,
    [Unsubscribe.name]: Unsubscribe
  },
  computed: {
    mandatoryRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v => (!!v && v.trim().length !== 0) || this.$i18n.t('global.validation.required.text')
      ]
    }
  },
  data() {
    return {
      editMode: false,
      isLoading: false,
      valid: false,
      isShowingUnsubscribe: false,
      model: {
        firstname: '',
        lastname: ''
      }
    };
  },

  created() {
    this.loadForm();
  },

  methods: {
    loadForm() {
      let user = store.state.user;
      this.model.firstname = user.firstname;
      this.model.lastname = user.lastname;
    },

    restoreForm() {
      this.loadForm();
      this.editMode = false;
    },

    async saveForm() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      this.isLoading = true;

      let results = await profileService.edit(this.model)

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        return;
      }

      this.isLoading = false;
      this.editMode = false;

      store.commit('UPDATE_USER_DATA', { firstname: this.model.firstname, lastname: this.model.lastname });

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('profile.firstname.update.success'),
        type: 'info',
        doNotTranslate: true
      });
    },

    unsubscribe() {
      this.isShowingUnsubscribe = true
    },

    closeUnsubscribe() {
      this.isShowingUnsubscribe = false
    }
  }
};
</script>
